// @flow
import React from 'react';
import { useTripContext } from 'trip/useTripContext';
import Rum from 'helpers/Rum';

function RumDataCollector(): null {
    const [{ tripInfo }] = useTripContext();
    const {
        status: { status },
        visitId: { clientId, taskId },
    } = tripInfo;

    React.useEffect(() => {
        Rum.setAttribute('status', status);
    }, [status]);

    React.useEffect(() => {
        Rum.setAttribute('clientId', clientId);
    }, [clientId]);

    React.useEffect(() => {
        Rum.setAttribute('taskId', taskId);
    }, [taskId]);

    React.useEffect(() => {
        Rum.setAttribute('language', navigator?.language);
    }, []);

    return null;
}

export default RumDataCollector;
